import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'csgofast-prize-overlay',
  templateUrl: './prize-overlay.component.html',
  styleUrls: ['./prize-overlay.component.scss'],
})
export class PrizeOverlayComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
